import React from "react";
import { Widget } from "@typeform/embed-react";

const TypeformEmbed = ({ id, open }) => {
  return <>{open && <Widget inlineOnMobile id={id} style={{ flex: "1" }} />}</>;
};

export default TypeformEmbed;
